var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.alerts),function(alert,index){return _c('div',{key:'alert-' + index,staticClass:"alert",class:'alert-' + alert.type},[_vm._v(_vm._s(alert.message))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }